/*
*###############################################################################
*Module Name                   : SearchDashboard.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect, useContext } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Alert,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import SearchDashboardContent from './SearchDashboardContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import DPPrintOption from 'framework/widgets/DPPrintOptions'

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
//**End Importing required componant files */

const SearchDashboard = (props) => {

    let history = useHistory();
    //Values from designation context

    //*** User input related states */
    const [strDesigCode, SetCode] = useState("");// Set Code
    const [strDesigDesc, SetDescription] = useState("")//Set Description
    const [IsActive, SetActive] = useState(true)//Set Active state
    const [menuCode, SetMenuCode] = useState("")
    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    //*** End User activity related staes */

    //Alert Parameters
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*** Get and Set values when user search code */

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)

    const [Excelitems, setExcelItems] = useState([]);
    const [helpUrl, setHelpUrl] = useState("")
    //import from contexts
    const {
        getMenuDetails
    } = useContext(Context);
    //import from contexts

    var time = process.env.REACT_APP_ALERTTIMEOUT

    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL


    //**Get File Details */
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]

        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName

        SetParentName(parentname)
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)


        var requestOptions = {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                SetMenuAccess(result.data.strMenuAccessRight)
                SetMenuCreate(result.data.strMenuCreateRight)
                SetMenuDelete(result.data.strMenuDeleteRight)
                SetMenuModify(result.data.strMenuModifyRight)
                SetMenuPrint(result.data.strMenuPrintRight)
                SetMenuProcess(result.data.strMenuProcessRight)
                SetMenuName(result.data.strMenuName)
                SetMenuCode(result.data.strMenuTag)
                setPermissionReasonShow(result.data.strMenuReasonShow)
                setHelpUrl(result.data.strHelpUrl)
                fetch(`${ApiURL}common/autocode/${result.data.strMenuTag}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                }).then(Response => Response.json())
                    .then(responseData => {
                        if (responseData.success == true) {
                            if (responseData.data.length == 0) {
                                setNullCode(true)
                            } else {
                                setAutoCode(responseData.data)
                            }
                        } else {
                            setNullCode(true)
                        }
                    })

            }).catch(error =>
                console.log('error', error)
            );

    }, [strDesigCode])

    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');

        const AuditLog = {
            "strMenuCode": menu,
            "strUserName": LogUserType,
            "strLocCode": LocationCode,
            "strComcode": CompanyCode,
            "strReason": ""
        }
        var requestOptions = {
            method: 'POST',
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
            body: JSON.stringify(AuditLog),
        };

        fetch(`${ApiURL}login/menu/audit`, requestOptions)
            .then(async (response) => await response.json())
            .then(result => {
                console.log(result)
            }).catch(error =>
                console.log('error', error)
            );

    }, [])




    //*** End useEffect */
    // print Function
    async function handlePrint(option) {

    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    //save button function
    const handlesave = async (e) => {

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Saving...")


    }

    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {
        SetCode(row.CD_CODE);

        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrEnable(true)
    }
    //*** End of getSelectedRow function */

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
    }

    //new button function
    const handleNew = e => {
        //e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
    }

    //clear fields function    
    const ClearItem = () => {
        SetCode("")
        SetDescription("")
        SetActive(true)
        setDisabledCode(false)
        setDisabled(false)
        setShow(false)
        setCrEnable(false)
        setErrorMsg('')
        SetAddNew(true)
        SetDeleteEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        SetEditEnable(false)
        setSaveEnable(true)
        setReason("Created")
        SetEditEnable(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setExcelItems([])
        setTimeout(() => {
            setExcelItems([])
        }, 1)
    }


    const handleDelete = () => {

    }





    //**Permission Check */
    const permission = (operation) => {
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {

                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }


    // Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <Row>

                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    {show ? (
                                        <Alert color={AlertColor} role="alert">
                                            {AlertMsg}
                                            <br />
                                            <small>{ErrorMsg}</small>
                                        </Alert>
                                    ) : null}
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {

                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }

                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                window.location.href = "/";
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    setprintoptionShow(true)
                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 5) {

                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            }
                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)
                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlePrint("PDF")
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlePrint("XCEL")
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                permission("Print")
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />

                                    <Row>
                                        <SearchDashboardContent
                                            menuCode={menuCode}
                                            setShow={setShow}
                                            setAlertMsg={setAlertMsg}
                                            setAlertColor={setAlertColor}
                                            SetLoadingAlert={SetLoadingAlert}
                                            SetLoadingAlerttitle={SetLoadingAlerttitle}
                                        />
                                    </Row>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default SearchDashboard